/*
  VBRNTT open vendor applications: re-checks the enrollment window in the
  browser. The server already sorts fairs into open now / opening soon and
  drops closed ones; this only catches a date that passed while the page sat
  in a cache. Each row carries data-opens (Unix seconds at the start of the
  open day in shop time, 0 = open now) and data-closes (end of the close day,
  0 = no close date).
  - a row whose close date passed is hidden
  - an opening-soon row whose open date passed moves up to the open list,
    with its close wording and apply button
  - the open heading and list show only while a row is open; otherwise the
    "nothing open" block shows instead
  Without JavaScript the server-rendered lists stand.
*/
if (!customElements.get('vbrntt-vendor-fairs')) {
  customElements.define(
    'vbrntt-vendor-fairs',
    class VbrnttVendorFairs extends HTMLElement {
      connectedCallback() {
        const now = Date.now() / 1000;
        const openList = this.querySelector('[data-fair-list]');
        this.querySelectorAll('[data-fair-row]').forEach((row) => {
          const opens = Number(row.dataset.opens) || 0;
          const closes = Number(row.dataset.closes) || 0;
          if (closes > 0 && closes <= now) {
            row.hidden = true;
            return;
          }
          if (opens > 0 && opens <= now && openList && !openList.contains(row)) {
            row.querySelectorAll('[data-soon-text]').forEach((el) => { el.hidden = true; });
            row.querySelectorAll('[data-open-text], [data-apply]').forEach((el) => { el.hidden = false; });
            openList.appendChild(row);
          }
        });
        const visible = (list) => (list ? Array.from(list.querySelectorAll('[data-fair-row]')).some((row) => !row.hidden) : false);
        const empty = this.querySelector('[data-fair-empty]');
        const anyOpen = visible(openList);
        if (empty) empty.hidden = anyOpen;
        this.querySelectorAll('[data-open-only]').forEach((el) => { el.hidden = !anyOpen; });
        const soonGroup = this.querySelector('[data-soon-group]');
        if (soonGroup) soonGroup.hidden = !visible(soonGroup.querySelector('[data-soon-list]'));
      }
    }
  );
}
